import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import { mlbSummaryReducer, formUserInteractionReducer } from './components/Form/FormContainer/ducks';

export const mainReducer = combineReducers({
  mlbSummary: mlbSummaryReducer,
  form: formReducer,
  formUserInteractionReducer,
});
